import { iconDefaults, type IconProps } from './Icon'

export function MenuIcon(props: IconProps) {
  return (
    <svg {...iconDefaults} {...props}>
    <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  )
}
